/**
 * Shared i18n text helpers.
 *
 * Components pass their English text as the t() default, so they also read right when i18n
 * isn't initialised (most unit tests). In that mode i18next doesn't fill {{vars}}, so tv()
 * fills them itself; with i18n running it changes nothing.
 */
import type { TFunction } from 'i18next';

export type Vars = Record<string, string | number>;

/** Replace {{name}} placeholders; unknown names are left as they are. */
export function fill(s: string, vars: Vars): string {
  return s.replace(/\{\{\s*(\w+)\s*\}\}/g, (m, k: string) => (k in vars ? String(vars[k]) : m));
}

/** t() with an English fallback and {{vars}}. */
export function tv(t: TFunction, key: string, fallback: string, vars: Vars = {}): string {
  return fill(String(t(key, fallback, vars)), vars);
}

/**
 * BCP 47 locale for Intl / toLocale* from the app language. English means en-GB (24-hour
 * clock, day-month order) and Norwegian means nb, matching dateLocale().
 */
export function intlLocale(language: string | undefined): string {
  const base = (language ?? 'en').toLowerCase().split('-')[0]!;
  if (base === 'en') return 'en-GB';
  if (base === 'no') return 'nb';
  return base;
}
